/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_DescriptionInputs */

const en_knp_guide_description = /** @type {(inputs: Knp_Guide_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a KNP guide to improve transcription accuracy for specific terms.`)
};

const fr_knp_guide_description = /** @type {(inputs: Knp_Guide_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez un guide KNP pour améliorer la précision de transcription pour des termes spécifiques.`)
};

const de_knp_guide_description = /** @type {(inputs: Knp_Guide_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie einen KNP-Leitfaden, um die Transkriptionsgenauigkeit für bestimmte Begriffe zu verbessern.`)
};

const it_knp_guide_description = /** @type {(inputs: Knp_Guide_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona una guida KNP per migliorare la precisione della trascrizione per termini specifici.`)
};

const ru_knp_guide_description = /** @type {(inputs: Knp_Guide_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите руководство KNP для повышения точности транскрипции конкретных терминов.`)
};

const es_knp_guide_description = /** @type {(inputs: Knp_Guide_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione una guía KNP para mejorar la precisión de la transcripción para términos específicos.`)
};

const zh_cn2_knp_guide_description = /** @type {(inputs: Knp_Guide_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择 KNP 指南以提高特定术语的转录准确性。`)
};

const ja_knp_guide_description = /** @type {(inputs: Knp_Guide_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`特定の用語の転写精度を向上させるには、KNP ガイドを選択します。`)
};

const hi_knp_guide_description = /** @type {(inputs: Knp_Guide_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विशिष्ट शब्दों के लिए प्रतिलेखन की सटीकता में सुधार करने के लिए एक केएनपी गाइड का चयन करें।`)
};

const pt_pt2_knp_guide_description = /** @type {(inputs: Knp_Guide_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um guia KNP para melhorar a precisão da transcrição de termos específicos.`)
};

/**
* | output |
* | --- |
* | "Select a KNP guide to improve transcription accuracy for specific terms." |
*
* @param {Knp_Guide_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_description = /** @type {((inputs?: Knp_Guide_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_description(inputs)
	if (locale === "de") return de_knp_guide_description(inputs)
	if (locale === "it") return it_knp_guide_description(inputs)
	if (locale === "ru") return ru_knp_guide_description(inputs)
	if (locale === "es") return es_knp_guide_description(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_description(inputs)
	if (locale === "ja") return ja_knp_guide_description(inputs)
	if (locale === "hi") return hi_knp_guide_description(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_description(inputs)
	return en_knp_guide_description(inputs)
});